import { TimeSlotContainer } from './components/time-slots/time-slot-container';
import React, { useEffect, useMemo, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { LecturerRatesVersions } from '../../../../api/types/lecturers/price-rate/lecturer-rate-res';
import { LecturerType } from '../../../../api/types/programs/course/lecturers/course-lecturer';
import globalCourseStore from '../../../../stores/global-course-store';
import { LecturerRatesById } from '../../../../api/types/lecturers/user-details-lecturer';
import globalConfigStore from '../../../../stores/global-config-store';
import appApi from '../../../../api/app-api';
import { Calendar } from 'primereact/calendar';
import { EditNumber } from '../../../../component/ui/edit-text/edit-number';
import { Button } from 'primereact/button';
import { SelectedSlotsState } from './components/time-slots/types/selected-slots';
import { AvailabilitySlot } from '../../../../api/types/calender/avalability-slots/availability-slot';
import globalProgramStore from '../../../../stores/program-store';
import { toast } from 'react-toastify';
import { ScheduleType } from '../../create-calendar-schedule-dialog';
import { InputSwitch } from 'primereact/inputswitch';

export type LecturerWithActivityId = LecturerType & {
  activityType: LecturerRatesVersions | null;
};

export type LecturerIdWithActivityTypeId = {
  lecturerId: number;
  activityTypeId: number | undefined;
};

interface CreateLectureSerialTabDatamodel {
  branchId: number;
  supportMultiple: boolean;
  timeSlot:
    | {
        start: Date;
        end: Date;
        classId: number;
      }
    | null
    | undefined;
  onApprove: (
    selectedSlotsState: SelectedSlotsState,
    lecturesIdsWithActivityTypeId: LecturerIdWithActivityTypeId[],
    setIsLoadingCreateLectures: (loading: boolean) => any,
    onHide: () => any,
    attendanceRequired?: boolean,
  ) => any;
  onHide: () => any;
  scheduleType: ScheduleType;
  editTimeSlot: {
    start: Date;
    end: Date;
    classId: number;
  };
}
export const CreateLectureSerialTab: React.FC<
  CreateLectureSerialTabDatamodel
> = ({
  branchId,
  supportMultiple,
  timeSlot,
  onApprove,
  onHide,
  scheduleType,
  editTimeSlot,
}) => {
  const [selectedLectures, setSelectedLectures] = useState<
    LecturerWithActivityId[] | null
  >(null);

  const [attendanceRequire, setAttendanceRequire] = useState(true);

  const courseLectures = useMemo(() => {
    return globalCourseStore.getCurrentCourse()?.details?.lecturer || [];
  }, [globalCourseStore]);

  const [lecturerRateById, setLecturerRateById] =
    useState<LecturerRatesById | null>(null);

  const [startDate, setStartDate] = useState<Date | null>(
    timeSlot?.start ?? null,
  );

  const handleDateChange = (e: any) => {
    if (e.target.value instanceof Date || e.target.value === null) {
      setStartDate(e.target.value);
    }
  };

  const [startTime, setStartTime] = useState<Date | null>(timeSlot?.start);
  const [endTime, setEndTime] = useState<Date | null>(timeSlot?.end);

  const [numberOfIterations, setNumberOfIterations] = useState(1);

  const [isLoadingCreateLectures, setIsLoadingCreateLectures] = useState(false);

  useEffect(() => {
    const logic = async () => {
      const userIds: number[] = selectedLectures?.map((item) => item.id);
      console.log(`XXXXX userIds: ${userIds}`);

      //const branch = globalConfigStore.rootFilter.currentBranches;
      if (branchId) {
        const lecturerPaymentRateRes =
          await appApi.getUserLecturerPaymentRateByBranchId(userIds, branchId);

        const lecturerPaymentRate = lecturerPaymentRateRes.data.body;
        setLecturerRateById(lecturerPaymentRate);
        console.log(`XXXXX userIds: ${JSON.stringify(lecturerPaymentRate)}`);
      }
    };

    if (selectedLectures && selectedLectures.length > 0) {
      logic();
    }
  }, [selectedLectures]);

  const handleSelectedActivityTypeForLecturer = (
    lecturer: LecturerType,
    selectedActivityType: LecturerRatesVersions,
  ) => {
    setSelectedLectures((prevSelectedLectures) => {
      if (!prevSelectedLectures) return null;

      return prevSelectedLectures.map((item) =>
        item.id === lecturer.id
          ? { ...item, activityType: selectedActivityType }
          : item,
      );
    });
  };

  useEffect(() => {
    //handleCreateSerialLectures();
  }, [scheduleType, timeSlot]);

  const handleCreateSerialLectures = async () => {
    const programId = globalProgramStore.getCurrentId();
    const courseId = globalCourseStore.getCurrentCourse()?.metadata.id;

    if (selectedLectures?.some((item) => item.activityType === null)) {
      toast.warn('יש לבחור למרצה את סוג הפעילות המתאים');
      return;
    }

    const lecturesIds: LecturerIdWithActivityTypeId[] =
      selectedLectures?.map((item) => ({
        lecturerId: item.id,
        activityTypeId: item.activityType?.lecturersRateType.id,
      })) ?? [];

    onApprove(
      selectedSlots,
      lecturesIds,
      setIsLoadingCreateLectures,
      onHide,
      attendanceRequire,
    );
  };

  // Initialize state with explicit type
  const [selectedSlots, setSelectedSlots] = useState<SelectedSlotsState>({});

  const SUPPORT_MULTIPLE = supportMultiple;

  const handleSlotSelect = (
    lectureNumber: number,
    slot: AvailabilitySlot | null,
  ) => {
    if (!slot?.isAvailable) return;

    setSelectedSlots((prev) => {
      const current = prev[lectureNumber] || [];
      const slotIndex = current.findIndex((s) => s.classId === slot.classId);

      // If found, remove it
      if (slotIndex >= 0) {
        return {
          ...prev,
          [lectureNumber]: current.filter((_, i) => i !== slotIndex),
        };
      }

      // For single selection mode, replace the existing slot
      // For multiple selection mode, add to existing slots
      const newSlots = SUPPORT_MULTIPLE
        ? [...current, { lectureNumber, ...slot }]
        : [{ lectureNumber, ...slot }];

      return { ...prev, [lectureNumber]: newSlots };
    });
  };

  return (
    <div>
      <div style={{ marginTop: '16px' }} />
      <label style={{ fontSize: '14px', color: '#4b5563' }}>תאריך התחלה</label>
      <Calendar
        id="buttondisplay"
        style={{
          height: '36px',
          width: '100%',
          direction: 'ltr',
          marginTop: '8px',
        }}
        dateFormat={'dd/mm/yy'}
        inputStyle={{ textAlign: 'right' }}
        value={startDate}
        onChange={handleDateChange}
        showIcon={true}
        iconPos={'right'}
        yearNavigator={true}
        yearRange={`${new Date().getFullYear() - 1}:2027`}
      />
      <div style={{ marginTop: '16px' }} />
      <label style={{ fontSize: '14px', color: '#4b5563' }}>בחירת מרצים</label>
      <MultiSelect
        value={selectedLectures}
        onChange={(e) => setSelectedLectures(e.value)}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '36px',
        }}
        options={courseLectures}
        emptyMessage={'לא נמצאו נתונים'}
        optionLabel={(option) => `${option.firstName} ${option.lastName}`}
        itemTemplate={(option) => `${option.firstName} ${option.lastName}`}
        placeholder="בחירת מרצה"
        maxSelectedLabels={3}
      />

      {lecturerRateById &&
        selectedLectures.map((item) => (
          <div>
            <div
              style={{ marginTop: '8px', fontSize: '14px', color: '#4b5563' }}
            >
              בחירת סוג פעילות ל{`${item.firstName} ${item.lastName}`}
            </div>
            <Dropdown
              value={item.activityType || null}
              onChange={(e) =>
                handleSelectedActivityTypeForLecturer(item, e.value)
              }
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '36px',
              }}
              options={lecturerRateById[item.id]}
              optionLabel="lecturersRateType.typeRateName"
              itemTemplate={(option: LecturerRatesVersions) => {
                return option.lecturersRateType.typeRateName;
              }}
              placeholder="בחירת סוג פעילות"
            />
          </div>
        ))}

      <div style={{ marginTop: '16px' }} />
      <label style={{ fontSize: '14px', color: '#4b5563' }}>בחירת שעות</label>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <Calendar
          style={{ height: '36px', width: '100%', direction: 'ltr' }}
          panelStyle={{
            direction: 'ltr',
          }}
          value={startTime}
          inputStyle={{ textAlign: 'right' }}
          onChange={(e) => setStartTime(e.value)}
          timeOnly
          showIcon
          icon={() => <i className="pi pi-clock" />}
        />
        <div style={{ marginLeft: '8px', marginRight: '8px' }}>עד</div>
        <Calendar
          style={{
            height: '36px',
            width: '100%',
            direction: 'ltr',
          }}
          panelStyle={{
            direction: 'ltr',
          }}
          value={endTime}
          inputStyle={{ textAlign: 'right' }}
          onChange={(e) => setEndTime(e.value)}
          timeOnly
          showIcon
          icon={() => <i className="pi pi-clock" />}
        />
      </div>

      <div style={{ marginTop: '16px' }} />
      <EditNumber
        title={'מספר שיבוצים'}
        disabled={scheduleType === ScheduleType.EXAM}
        value={numberOfIterations}
        onChange={setNumberOfIterations}
      />

      {scheduleType === ScheduleType.LECTURE && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '16px',
            alignItems: 'center',
            marginBottom: '16px',
            /*justifyContent: 'space-between',*/
          }}
        >
          <label>נוכחות חובה</label>
          <InputSwitch
            checked={attendanceRequire}
            onChange={(e) => setAttendanceRequire(e.value)}
          />
        </div>
      )}

      <TimeSlotContainer
        branchId={branchId}
        startDate={startDate}
        endTime={endTime}
        startTime={startTime}
        iterationNumber={numberOfIterations}
        selectedSlots={selectedSlots}
        handleSlotSelect={handleSlotSelect}
        shouldInitiateSearchSlot={scheduleType === ScheduleType.EXAM}
        editTimeSlot={editTimeSlot}
      />

      <Button
        style={{ height: '30px', marginTop: '8px' }}
        label={'אישור'}
        loading={isLoadingCreateLectures}
        onClick={handleCreateSerialLectures}
      />
    </div>
  );
};
